// src/modals/TransferModal.js
import React, { useState, useCallback } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
} from "reactstrap";
import "./modal.css";

// ✅ RTK Query mutation hook
import { useTransferProductsMutation } from "../api/api";
import { getApiErrorMessage } from "../api/errorUtils";

const TransferModal = ({
  modalOpen,
  productsData,
  toggleModal,
  locationsData,
  notificationComponentRef,
}) => {
  const [location, setLocation] = useState("");
  const [transferProducts, { isLoading }] = useTransferProductsMutation();

  const selectedProductIds = productsData
    .filter((product) => product.selected)
    .map((product) => product.id);

  const handleTransfer = async () => {
    try {
      if (!location) throw new Error("Please select a location!");
      if (selectedProductIds.length === 0)
        throw new Error("Please select products!");

      // ✅ Use RTK mutation
      await transferProducts({
        ids: selectedProductIds,
        location,
      }).unwrap();

      toggleModal();
      notificationComponentRef.current.showNotification(
        `Products with IDs ${selectedProductIds.join(
          ", "
        )} have been transferred successfully`,
        "success"
      );
    } catch (error) {
      const message =
        typeof error === "string"
          ? error
          : getApiErrorMessage(error, "Transfer failed", {
              404: "The selected location or one of the selected products is outside your company scope.",
            });
      notificationComponentRef.current.showNotification(message, "danger");
      console.error("Error during transfer:", error);
    }
  };

  const handleTransferChange = useCallback((e) => {
    setLocation(e.target.value);
  }, []);

  return (
    <Modal className="add-item-modal" isOpen={modalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Transfer Products</ModalHeader>
      <ModalBody>
        <h4>Where do you want to transfer these products?</h4>
        <FormGroup>
          <label>Location</label>
          <Input type="select" value={location} onChange={handleTransferChange}>
            <option value="">-- Select Location --</option>
            {locationsData.map((loc) => (
              <option key={loc.id} value={loc.id}>
                {loc.name}
              </option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleTransfer} disabled={isLoading}>
          {isLoading ? "Transferring..." : "Transfer"}
        </Button>
        <Button color="secondary" onClick={toggleModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TransferModal;
